import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { QRCodeCanvas } from "qrcode.react";
import jsPDF from "jspdf";

export default function ComprovantePagamento() {
  const { search } = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(search);

  const rawPaymentId =
    params.get("payment_id") ||
    params.get("collection_id") ||
    params.get("PAYMENT_ID") ||
    params.get("COLLECTION_ID");

  const payment_id = rawPaymentId ? rawPaymentId.replace(/\D/g, "") : null;

  const status =
    params.get("status") ||
    params.get("collection_status") ||
    params.get("STATUS") ||
    params.get("COLLECTION_STATUS");

  const [cobranca, setCobranca] = useState(null);
  const [loading, setLoading] = useState(true);
  const [falhaBusca, setFalhaBusca] = useState(false);
  const qrRef = useRef();

  const BASE_URL =
    window.location.hostname === "localhost"
      ? "http://localhost:4000"
      : "https://painel-cobranca.onrender.com";

      useEffect(() => {
        if (payment_id) {
          const normalizedId = payment_id.replace(/\D/g, "");
      
          axios
            .get(`${BASE_URL}/api/buscar-por-payment-id/${normalizedId}`)
            .then((res) => {
              if (res.data) {
                setCobranca(res.data);
                setFalhaBusca(false);
              } else {
                axios
                  .get(`${BASE_URL}/api/buscar-por-payment-id/${payment_id}`)
                  .then((fallbackRes) => {
                    if (fallbackRes.data) {
                      setCobranca(fallbackRes.data);
                      setFalhaBusca(false);
                    } else {
                      setFalhaBusca(true);
                    }
                  })
                  .catch(() => setFalhaBusca(true));
              }
            })
            .catch((error) => {
              console.error("Erro ao buscar comprovante:", error);
              setFalhaBusca(true);
            })
            .finally(() => setLoading(false));
        } else {
          setLoading(false);
        }
      }, [payment_id]);

  const urlComprovante = window.location.href;

  const gerarPDF = () => {
    const doc = new jsPDF();
    doc.setFontSize(18);
    doc.text("Comprovante de Pagamento - Santista Experience", 15, 20);
    doc.setFontSize(12);
    doc.text("Agradecemos sua compra!", 15, 32);
    doc.text(`Status: ${status || cobranca?.status || "---"}`, 15, 44);
    doc.text(`Nome: ${cobranca?.nome || ""}`, 15, 52);
    doc.text(
      `Valor: R$ ${Number(cobranca?.valor || 0).toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
      })}`,
      15,
      60
    );
    doc.text(
      `Data: ${
        cobranca?.criado_em
          ? new Date(cobranca?.criado_em).toLocaleString("pt-BR")
          : ""
      }`,
      15,
      68
    );
    doc.text(`E-mail: ${cobranca?.email || ""}`, 15, 76);
    doc.text(`ID do Pagamento: ${payment_id || ""}`, 15, 84);
    doc.text(`Referência do vendedor: ${cobranca?.external_reference || ""}`, 15, 92);

    if (cobranca?.metodo === "pix" && cobranca?.qr_code_base64) {
      doc.text("Pix (QR Code):", 15, 110);
      doc.addImage(cobranca.qr_code_base64, "PNG", 80, 115, 40, 40);
      doc.text("Pix Copia e Cola:", 15, 160);
      doc.setFontSize(8);
      doc.text(cobranca.qr_code || "", 15, 165, { maxWidth: 180 });
      doc.setFontSize(10);
    } else {
      doc.text(
        "Acesse este comprovante online escaneando o QR Code:",
        15,
        110
      );
      const qrCanvas = qrRef.current?.querySelector("canvas");
      if (qrCanvas) {
        const qrImage = qrCanvas.toDataURL("image/png");
        doc.addImage(qrImage, "PNG", 80, 120, 40, 40);
      }
    }

    doc.setFontSize(10);
    doc.text(
      "Guarde este comprovante. Para nota fiscal, consulte seu e-mail ou fale com o suporte.",
      15,
      200
    );
    doc.save(`comprovante_pagamento_${payment_id}.pdf`);
  };

  const numeroWhatsapp = "55115726299881";
  const mensagemWhatsApp = encodeURIComponent(
    `Olá! Segue meu comprovante de pagamento na Santista Experience:\n\n` +
      `✅ Pagamento aprovado!\n` +
      `Nome: ${cobranca?.nome || ""}\n` +
      `Valor: R$ ${Number(cobranca?.valor || 0).toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
      })}\n` +
      `ID da transação: ${payment_id || ""}\n` +
      `Data: ${
        cobranca?.criado_em
          ? new Date(cobranca?.criado_em).toLocaleString("pt-BR")
          : ""
      }\n` +
      `Acesse o comprovante digital aqui: ${urlComprovante}\n`
  );
  const urlWhatsApp = `https://wa.me/${numeroWhatsapp}?text=${mensagemWhatsApp}`;

  if (loading)
    return (
      <div className="flex items-center justify-center min-h-screen text-lg text-gray-600">
        Carregando comprovante...
      </div>
    );

  if (!payment_id)
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-6">
        <div className="bg-white rounded-xl shadow-xl max-w-md w-full p-8 border-t-8 border-green-500 flex flex-col items-center">
          <h1 className="text-2xl font-bold text-green-700 mb-2">
            Pagamento realizado!
          </h1>
          <p className="mb-4 text-gray-700 text-center">
            Não foi possível recuperar todos os dados do pagamento, mas sua transação foi concluída.
          </p>
          <button
            onClick={() => navigate("/")}
            className="bg-indigo-700 hover:bg-indigo-800 text-white font-bold rounded-xl py-3 px-8 mt-4 shadow-md transition"
          >
            Voltar ao início
          </button>
        </div>
      </div>
    );

  if (falhaBusca)
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-6">
        <div className="bg-white rounded-xl shadow-xl max-w-md w-full p-8 border-t-8 border-yellow-500 flex flex-col items-center">
          <img
            src="https://cdn-icons-png.flaticon.com/512/463/463612.png"
            alt="Aviso"
            width={64}
            height={64}
            className="mb-4 opacity-70"
          />
          <h2 className="text-2xl font-bold text-yellow-700 mb-3 text-center">
            Comprovante não encontrado
          </h2>
          <p className="mb-4 text-gray-700 text-center">
            Não foi possível localizar o comprovante de pagamento.<br />
            <span className="font-semibold text-gray-800">
              Mas fique tranquilo, seu pagamento foi processado.<br />
              Se precisar de ajuda, envie o código abaixo para o WhatsApp da loja:
            </span>
          </p>
          <div className="mb-2">
            <p className="text-sm text-gray-600">ID original: {rawPaymentId}</p>
            <p className="text-sm text-gray-600">ID normalizado: {payment_id}</p>
          </div>
          <div className="font-mono text-lg font-bold bg-gray-200 rounded-md px-4 py-2 mb-4 border border-gray-300 tracking-wider select-all">
            {payment_id}
          </div>
          <a
            href={urlWhatsApp}
            target="_blank"
            rel="noopener noreferrer"
            className="w-full bg-green-600 hover:bg-green-700 text-white font-bold rounded-xl py-3 px-8 shadow-md transition text-center mb-2"
          >
            Falar com a loja no WhatsApp
          </a>
        </div>
      </div>
    );

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-6">
      <div className="bg-white rounded-xl shadow-xl max-w-xl w-full p-8 border-t-8 border-green-500">
        <h2 className="text-xl font-bold text-green-700 mb-2">Pagamento aprovado!</h2>
        <div className="mb-4 text-gray-800">
          <p className="mb-2">
            <b>
              Obrigado por comprar com a{" "}
              <span className="text-indigo-700">Santista Experience</span>!
            </b>
          </p>
          <p className="mb-2 text-sm">
            Compartilhamos os detalhes do seu pagamento abaixo:
          </p>
        </div>
        <div className="bg-gray-50 p-4 rounded-lg mb-4 shadow-inner">
          <p>
            <b>Status:</b>{" "}
            <span className="text-green-700">
              {status === "approved"
                ? "Aprovado"
                : status || cobranca?.status || "---"}
            </span>
          </p>
          <p>
            <b>Valor:</b> R${" "}
            {Number(cobranca?.valor || 0).toLocaleString("pt-BR", {
              minimumFractionDigits: 2,
            })}
          </p>
          <p>
            <b>ID do Pagamento:</b> {payment_id || "---"}
          </p>
          <p>
            <b>Referência do vendedor:</b> {cobranca?.external_reference || ""}
          </p>
          <p>
            <b>Nome:</b> {cobranca?.nome || ""}
          </p>
          <p>
            <b>E-mail:</b> {cobranca?.email || ""}
          </p>
          <p>
            <b>Data:</b>{" "}
            {cobranca?.criado_em
              ? new Date(cobranca?.criado_em).toLocaleString("pt-BR")
              : ""}
          </p>
        </div>

        {cobranca?.metodo === "pix" ? (
  <div className="flex flex-col items-center my-4">
    <h3 className="text-lg font-semibold text-green-700 mb-2">Pagamento via Pix confirmado!</h3>
    <p className="text-sm text-gray-700 mb-2 text-center">
      Obrigado pela sua compra! Aproveite para nos seguir no Instagram:
    </p>
    <QRCodeCanvas
      value="https://www.instagram.com/santista.exclusivostanley"
      size={120}
      includeMargin
      level="M"
    />
    <p className="mt-2 text-xs text-gray-500">@santista.exclusivostanley</p>
  </div>
) : (
  <div className="flex flex-col items-center my-4" ref={qrRef}>
    <b>Comprovante Digital (QR Code):</b>
    <QRCodeCanvas value={urlComprovante} size={120} includeMargin level="M" />
  </div>
)}

        <div className="bg-yellow-100 p-4 rounded-lg my-4 text-sm">
          <b>Instruções:</b>
          <ul className="list-disc ml-6">
            <li>Salve ou baixe este comprovante em PDF.</li>
            <li>Use o QR Code para seguir nosso Instagram.</li>
            <li>
              Para nota fiscal, consulte seu e-mail ou entre em contato pelo WhatsApp da loja.
            </li>
            <li>Em caso de dúvida, envie este PDF para nosso suporte.</li>
          </ul>
        </div>
        <button
          onClick={gerarPDF}
          className="bg-indigo-700 hover:bg-indigo-800 text-white font-bold rounded-xl py-3 px-8 mt-4 shadow-md transition"
        >
          Baixar comprovante em PDF
        </button>

        <a
          href={urlWhatsApp}
          target="_blank"
          rel="noopener noreferrer"
          className="block mt-3 bg-green-600 hover:bg-green-700 text-white font-bold rounded-xl py-3 px-8 shadow-md transition text-center"
        >
          Encaminhar comprovante por WhatsApp
        </a>
        <br />
        {localStorage.getItem("painelAdmin") === "true" && (
          <a href="/" className="text-indigo-700 underline mt-4 block">
             Voltar ao início
               </a>
               )}
      </div>
    </div>
  );
}